import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from 'angular-toastify';
import { ClientQuotaDetail } from '../../../../../core/models/card-quota/client-quota.model';
import { MapperClientQuotaService } from '../../../../../core/mappers/card-quota/mapper-client-quota.service';
import { ApiCardQuotaService } from '../../../../../core/services/api/card-quota/api-card-quota.service';

@Component({
  selector: 'app-modal-client-quota-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-client-quota-detail.component.html',
  styleUrl: './modal-client-quota-detail.component.css',
})
export class ModalClientQuotaDetailComponent implements OnInit {
  @Input() quotaId = 0;
  @Output() close = new EventEmitter<void>();

  detail: ClientQuotaDetail | null = null;
  isLoading = signal(false);

  private readonly api = inject(ApiCardQuotaService);
  private readonly mapper = inject(MapperClientQuotaService);
  private readonly toast = inject(ToastService);

  levelLabel = (v: string) => this.mapper.quotaLevelLabel(v);
  statusLabel = (v: string) => this.mapper.quotaStatusLabel(v);

  ngOnInit(): void {
    if (this.quotaId > 0) this.load();
  }

  onClose(): void {
    this.close.emit();
  }

  private load(): void {
    this.isLoading.set(true);
    this.api.getClientQuotaById(this.quotaId).subscribe({
      next: (res) => {
        this.detail = this.mapper.mapDetail(res as ClientQuotaDetail & Record<string, unknown>);
        this.isLoading.set(false);
      },
      error: () => {
        this.toast.error('โหลดรายละเอียดไม่สำเร็จ');
        this.isLoading.set(false);
      },
    });
  }
}
